<template>
  <div class="objects-certificate_oce">

    <button-back
      class="of_back"
      :useHistory="true"
      :defaultRoute="'/objects/search'"/>
      <router-link
        class="help-link"
        style="text-align:center;"
        :to="{ path: '/help/12'}"
        target="_blank">
        Подробнее о сертификате в разделе Помощь
      </router-link>

    <div class="oce_page page-container">
      <div class="oce_grad-line"></div>
      <img src="/static/grx/logo/logo-b.png" class="oce_logo">
      <div class="oce_ipu-title">
        <span>Цифровая платформа</span> <span>обмена знаниями</span>
        <span>и управления авторскими</span> <span>правами</span></div>
      <div class="oce_page-title">Сертификат<br>
        <small>о депонировании и операциях с объектом авторского права</small>
      </div>
      <div v-if="objData" class="oce_id oce_break">{{ objData.ObjectId }}</div>
      <div v-if="objData" class="oce_title">{{ objData.Title }}</div>
      <div v-if="type" class="oce_info">
        <div class="oce_info-title oce_info-inline">Тип</div>
        <div class="oce_info-body oce_info-inline">{{ type.Title }}</div>
      </div>

      <div v-if="objData" class="oce_info">
        <div class="oce_info-title">Авторы (авторский вклад):</div>
        <div class="oce_info-body">
          <div
            v-for="(od, i) in objData.Authors"
            :key="`authors-${i}`"
            class="oce_holder">
            <el-tooltip content="Правообладатель" placement="top">
              <div v-if="od.IsCopyrightHolder" class="oce_holder-img">п</div>
            </el-tooltip>
            {{ [od.Surname, od.Name, od.Patronymic].join(' ') }}
            ({{ od.Stake }}/{{ objData.Authors.length }})
            <span v-if="od.IsCopyrightHolder" class="oce_holder-txt">
              правобладатель
            </span>
          </div>
        </div>
      </div>

      <div v-if="objData" class="oce_info">
        <div class="oce_info-title">Организации:</div>
        <div class="oce_info-body">
          <div
            v-for="(od, i) in objData.Organizations"
            :key="`orgs-${i}`"
            class="oce_holder">
            <el-tooltip content="Правообладатель" placement="top">
              <div v-if="od.IsCopyrightHolder" class="oce_holder-img">п</div>
            </el-tooltip>
            {{ od.Organization }}
            <span v-if="od.IsCopyrightHolder" class="oce_holder-txt">
              правобладатель
            </span>
          </div>
        </div>
      </div>

      <div v-if="objData" class="oce_info">
        <div class="oce_info-title oce_info-inline">Депонирован:</div>
        <div class="oce_info-body oce_info-inline">{{ createdTime }}</div>
      </div>

      <div v-if="objData && statusData && statusData.length > 0" class="oce_info">
        <div class="oce_info-title oce_info-inline">
          Информация о проверке сведений об ОАП и содержания ОАП правообладателями:
        </div>
        <div class="oce_info-body oce_info-inline">
          {{ formatUnixTime(statusData[0].TimeStamp) }} –
          {{ statusData[0].EventTitle }}.
        </div>
      </div>

      <div v-if="objData" class="oce_info">
        <div class="oce_info-title">Лицензионные условия (смарт-контракт):</div>
        <div class="oce_info-body">
          {{ this.licenses[objData.Licenses[0]].Title }}
        </div>
      </div>

      <div
        v-if="objData && objData.LicensesTerms && objData.LicensesTerms.length > 0"
        class="oce_info oce_info--lvl-2">
        <div class="oce_info-title">Установленные пределы права использования объекта:</div>
        <div
          v-for="(o, i) in objData.LicensesTerms"
          :key="`obj-lic-terms-${i}`"
          class="oce_info-body">
          {{ licensesTerms[o] }}
        </div>
      </div>

      <div
        v-if="objData && objData.LicensesInformation"
        class="oce_info oce_info--lvl-2">
        <div class="oce_info-title">Дополнительные лицензионные условия</div>
        <div class="oce_info-body">{{ objData.LicensesInformation }}</div>
      </div>

      <div v-if="objData" class="oce_info oce_info--lvl-2">
        <div class="oce_info-title">Доступ к цифровому объекту:</div>
        <div class="oce_info-body">
          Бесплатно с учетом лицензионных ограничений.
        </div>
      </div>

      <template v-if="objData && protectionDocs && protectionDocs.length > 0">
        <div class="oce_info">
          <div class="oce_info-body">Охранные документы:</div>
        </div>
        <div
          v-for="(doc, i) in protectionDocs"
          :key="`prot-doc-${i}`"
          class="oce_info oce_info--lvl-2">
          <template v-if="doc.Description">
            <div class="oce_info-body oce_info-inline">
              {{ doc.Description }}</div>
          </template>
          <template v-if="doc.Number">
            <div class="oce_info-title oce_info-inline">
              Номер регистрации (свидетельства):</div>
            <div class="oce_info-body oce_info-inline">
              {{ doc.Number}}.</div>
            <br>
          </template>
          <template v-if="doc.RelatedDocument && doc.RelatedDocument.RegistryName">
            <div class="oce_info-title oce_info-inline">
              Реестр:</div>
            <div class="oce_info-body oce_info-inline">
              {{ doc.RelatedDocument.RegistryName}}.</div>
            <br>
          </template>
          <template v-if="doc.RelatedDocument && doc.RelatedDocument.DocumentRegistrationDate">
            <div class="oce_info-title oce_info-inline">
              Дата регистрации в реестре:</div>
            <div class="oce_info-body oce_info-inline">
              {{ doc.RelatedDocument.DocumentRegistrationDate}}.</div>
          </template>
        </div>
      </template>

      <div class="oce_ext">
        <canvas ref="qrcode" class="oce_ext-qrcode"></canvas>
        <div class="oce_ext-title">Хэш блока в распределенном реестре:</div>
        <div v-if="sysData" class="oce_break">{{ sysData.HashBlock }}</div>
        <div class="oce_ext-title">Идентификатор транзакции депонирования:</div>
        <div v-if="sysData" class="oce_break">{{ sysData.TransactionId }}</div>
        <a v-if="objUrl" :href="objUrl" target="_blank" class="oce_ext-url oce_break">
          {{ objUrl }}</a>
      </div>
      <div class="oce_files-hash_ofh">
        <div class="ofh_title">Хеши файлов ОАП в распределенном реестре:</div>
        <div class="ofh_items" v-if="objData">
          <div class="ofh_item" v-for="(f, i) in objData.Files" :key="`file-hash-${i}`">
            {{ f.Hash }}
          </div>
        </div>
      </div>
      <div class="ops_print-wrap">
        <div class="ops_print-lnk" @click="print">Печать сертификата</div>
      </div>

      <div class="oce_ops" :class="{ 'oce_ops--on': opsOn }">
        <div class="oce_notice">
          Сертификат подтверждает верификацию правообладателями,
          депонирование и операции с объектом авторского права на платформе
        </div>
        <div>
          <span
            class="oce_ops-trigger"
            @click="opsOn = !opsOn">
            Все операции с объектом
          </span>
        </div>
        <div class="oce_ops-body" v-if="opsOn">
          <div class="oce_ops-item" v-for="(o, i) in eventsData" :key="`items-${i}`">
            <div class="oce_ops-item-date">{{ formatUnixTime(o.TimeStamp) }}</div>
            <div class="oce_ops-item-op">{{ o.EventTitle }}</div>
            <router-link :to="`/user/${o.UserId}/profile/view`"
              class="oce_ops-item-pers">{{ o.CreatorFio }}</router-link>
          </div>
        </div>
      </div>
    </div>

    <div class="oce_print-only oce_page pagebreak">
      <img src="/static/grx/logo/logo-b.png" class="oce_logo">
      <div class="oce_ipu-title">Цифровая платформа обмена знаниями<br>
        и управления авторскими правами</div>
      <div class="oce_page-title">Приложение к сертификату<br>
        <small>о депонировании и операциях с объектом авторского права</small>
      </div>
      <div v-if="objData" class="oce_id oce_break">{{ objData.ObjectId }}</div>
      <div v-if="objData" class="oce_title">{{ objData.Title }}</div>
      <div class="oce_ops oce_ops--on">
        <div class="oce_ops-title">Все операции с объектом</div>
        <div class="oce_ops-body">
          <div class="oce_ops-item" v-for="(o, i) in eventsData" :key="`items2-${i}`">
            <div class="oce_ops-item-date">{{ formatUnixTime(o.TimeStamp) }}</div>
            <div class="oce_ops-item-op">{{ o.EventTitle }}</div>
            <div class="oce_ops-item-pers">{{ o.CreatorFio }}</div>
          </div>
        </div>
      </div>
    </div>

    <page-footer/>

  </div>
</template>

<script>
/* eslint-disable arrow-body-style */
import axios from 'axios';
import qrcode from 'qrcode';
import licenses from '@/data/licenses';
import ButtonBack from '../ButtonBack';
import PageHeader from '../PageHeader';
import PageText from '../PageText';
import PageFooter from '../PageFooter';

export default {

  components: { ButtonBack, PageHeader, PageText, PageFooter },

  data() {
    return {
      objUrl: null,
      objData: null,
      sysData: null,
      eventsData: null,
      statusData: null,
      protectionDocs: null,
      objectId: '',
      opsOn: false,
      licenses,
    };
  },

  mounted() {
    this.fetchData();
  },

  watch: {
    $route() {
      this.fetchData();
    },
  },

  computed: {

    organizations() {
      return this.objData
        .Organizations.map(o => o.Organization)
        .join(', ');
    },

    authors() {
      const authors = [];
      if (this.objData && this.objData.Authors.length) {
        const stakes = this.objData.Authors.reduce((sum, current) => {
          return sum + current.Stake;
        }, 0);
        this.objData.Authors.forEach((data, i) => {
          authors[i] = {};
          authors[i].fio = `${data.Surname} ${data.Name}`;
          authors[i].fio += data.Patronymic ? ` ${data.Patronymic}` : '';
          authors[i].stake = `${data.Stake}/${stakes}`;
          authors[i].userId = data.UserId ? data.UserId : '';
        });
      }
      return authors.map(a => a.fio).join(', ');
    },

    type() {
      let type = null;
      if (this.objData && this.objData.Type) {
        type = this.$store.getters['types/getType'](this.objData.Type);
      }
      return type;
    },

    createdTime() {
      let time = '';
      if (this.objData && this.objData.CreatedTime) {
        time = this.formatUnixTime(this.objData.CreatedTime);
      }
      return time;
    },

    licensesTerms() {
      let terms = {};
      if (this.type) {
        this.type.Fields.some((field) => {
          if (field.Name === 'LicensesTerms') {
            if (field.WidgetOptions.Options) {
              terms = field.WidgetOptions.Options;
            }
            return true;
          }
          return false;
        });
      }
      return terms;
    },
  },

  methods: {

    formatUnixTime(uTime) {
      const d = new Date(uTime * 1000);
      const year = d.getUTCFullYear();

      let month = d.getUTCMonth() + 1;
      if (month < 10) month = `0${month}`;

      let date = d.getUTCDate();
      if (date < 10) date = `0${date}`;

      let hours = d.getUTCHours();
      if (hours < 10) hours = `0${hours}`;

      let minutes = d.getMinutes();
      if (minutes < 10) minutes = `0${minutes}`;

      return `${date}.${month}.${year} ${hours}:${minutes} UTC`;
    },

    print() {
      window.print();
    },

    fetchData() {
      this.$store.commit('setObjIsLoading', true);
      this.objectId = this.$route.params.objectId;
      if (this.objectId) {
        const eventQuery = '?events[]=CREATE_OBJECT&events[]=EDIT_OBJECT&events[]=BLOCK_OBJECT&events[]=UNBLOCK_OBJECT&events[]=OBJECT_STATUS_VERIFIED&events[]=OBJECT_STATUS_UNVERIFIED';
        axios.all([
          (() => axios.get(`objects/${this.objectId}?loadRelated=true&log=true`))(),
          (() => axios.get(`objects/${this.objectId}/systeminfo`))(),
          (() => axios.get(`objects/${this.objectId}/events${eventQuery}`))(),
          (() => axios.get(`objects/${this.objectId}/events?events[]=OBJECT_STATUS_VERIFIED&events[]=OBJECT_STATUS_UNVERIFIED`))(),
        ]).then(axios.spread((objResp, sysResp, evtResp, statusResp) => {
          this.objData = objResp.data;
          this.sysData = sysResp.data;
          this.eventsData = evtResp.data;
          this.statusData = statusResp.data;
          this.$store.commit('setObjIsLoading', false);
          this.objUrl = `${window.location.origin}/object/${this.objData.ObjectId}`;
          const ctr = this.$refs.qrcode;
          qrcode.toCanvas(ctr, this.objUrl, { scale: 2.7, margin: 0 });

          // Fill protection documents
          this.protectionDocs = [];
          this.log(this.objData.ProtectionDocuments);
          if (this.objData && this.objData.ProtectionDocuments) {
            Object.keys(this.objData.ProtectionDocuments).forEach((id) => {
              const curProtectionDoc = this.objData.ProtectionDocuments[id];
              const relatedDocId = `${curProtectionDoc.Number}@${curProtectionDoc.RegistryId}`;
              if (this.objData.Transient.RelatedRegistryDocuments
                && this.objData.Transient.RelatedRegistryDocuments[relatedDocId]) {
                curProtectionDoc.RelatedDocument =
                  this.objData.Transient.RelatedRegistryDocuments[relatedDocId];
              } else {
                curProtectionDoc.RelatedDocument = null;
              }
              this.protectionDocs.push(curProtectionDoc);
            });
          }
        }));
      }
    },

  },
};
</script>

<style lang="scss">
@import '../../styles/common/main';

$bp: 1030px;
$bp-sm: 670px;
$grey: #c2c2c2;

.objects-certificate_oce {
  .oce_page {
    max-width: 990px;
    margin: 0 auto;
    padding: 150px 120px 120px;
    background: url(/static/grx/bg-tiles.png);
    color: #000 !important;
    position: relative;
    @media (max-width: $bp) {
      padding: 14.5vw 11.6vw 11.6vw;
    }
    @media (max-width: $bp-sm) {
      padding: 15vw 7vw 7.6vw;
    }
    .oce_grad-line {
      height: 30px;
      @extend .grad;
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      @media (max-width: $bp) {
        height: 2.9vw;
      }
      @media (max-width: $bp-sm) {
        height: 20px;
      }
    }
    .oce_logo {
      max-width: 320px;
      height: auto;
      @media (max-width: $bp) {
        max-width: 31vw;
      }
      @media (max-width: $bp-sm) {
        max-width: 207px;
      }
    }
    .oce_ipu-title {
      font-size: 25px;
      line-height: 28px;
      position: absolute;
      top: 150px;
      right: 120px;
      text-align: right;
      font-weight: bold;
      span {
        display: block;
      }
      @media (max-width: $bp) {
        font-size: 2.43vw;
        line-height: 2.72vw;
        top: 14.56vw;
        right: 11.65vw;
      }
      @media (max-width: $bp-sm) {
        font-size: 16px;
        line-height: 18px;
      }
      @media (max-width: 560px) {
        font-size: 16px;
        line-height: 18px;
        position: static;
        text-align: left;
        margin-top: 7px;
        span {
          display: inline;
        }
      }
    }
    .oce_page-title {
      font-size: 55px;
      margin-top: 20px;
      font-weight: bold;
      small {
        font-size: 26px;
        line-height: 26px;
        color: $grey;
        font-weight: normal;
        display: block;
      }
      @media (max-width: $bp) {
        font-size: 5.8vw;
        small {
          font-size: 2.5vw;
          line-height: 2.1vw;
        }
      }
      @media (max-width: $bp-sm) {
        font-size: 38px;
        small {
          font-size: 19px;
          line-height: 19px;
        }
      }
    }
    .oce_id {
      $mult: .8;
      font-size: $mult * 33px;
      margin-top: 40px;
      font-weight: bold;
      @media (max-width: $bp) {
        font-size: $mult * 3.2vw;
        margin-top: $mult * 3.8vw;
      }
      @media (max-width: $bp-sm) {
        font-size: $mult * 24px;
        margin-top: $mult * 29px;
      }
    }
    .oce_title {
      $mult: .9;
      margin: $mult * 30px 0 20px;
      font-size: $mult * 30px;
      line-height: $mult * 32px;
      font-weight: 700;
      color: $color-2;
      -webkit-print-color-adjust: exact;
      @media (max-width: $bp) {
        font-size: $mult * 2.9vw;
        line-height: $mult * 3vw;
        margin-top: $mult * 3.1vw;
      }
      @media (max-width: $bp-sm) {
        font-size: $mult * 22px;
        line-height: $mult * 24px;
        margin-top: $mult * 23px;
      }
    }
    .oce_info {
      $mult: .9;
      font-size: $mult * 23px;
      margin-bottom: 15px;
      &.oce_info--lvl-2 {
        padding-left: 30px;
        font-size: $mult * 19px;
        @media (max-width: $bp) {
          font-size: $mult * 2.1vw;
        }
        @media (max-width: $bp-sm) {
          font-size: $mult * 15px;
        }
      }
      .oce_info-title {
        color: $grey;
      }
      .oce_info-body {
        color: #333;
      }
      .oce_info-inline {
        display: inline;
        margin-right: 4px;
      }
      @media (max-width: $bp) {
        font-size: $mult * 2.2vw;
      }
      @media (max-width: $bp-sm) {
        font-size: $mult * 15px;
      }
  }
    .oce_holder {
      padding-left: 30px;
      position: relative;
      .oce_holder-img {
        position: absolute;
        top: 2px;
        left: 0;
        cursor: default;
        width: 20px;
        height: 11.55px;
        background-color: $color-2;
        margin: 5.77px 0;
        color: #fff !important;
        text-align: center;
        font-size: 15px;
        line-height: 10px;
        &:before,
        &:after {
          content: "";
          position: absolute;
          left: 0;
          width: 0;
          border-left: 10px solid transparent;
          border-right: 10px solid transparent;
        }
        &:before {
          bottom: 100%;
          border-bottom: 5.77px solid $color-2;
        }
        &:after {
          top: 100%;
          width: 0;
          border-top: 5.77px solid $color-2;
        }
      }
      .oce_holder-txt {
        display: none;
      }
    }
    .oce_ext {
      color: #333;
      padding-top: 15px;
      .oce_ext-qrcode {
        float: left;
        margin-right: 10px;
      }
      .oce_ext-title {
        color: $grey;
      }
      .oce_ext-url {
        text-decoration: underline;
        color: $color-2 !important;
        display: block;
        &:hover {
          text-decoration: none;
        }
      }
    }
    .oce_files-hash_ofh {
      margin-top: 20px;
      .ofh_title {
        color: $grey;
      }
      .ofh_items {}
      .ofh_item {
        word-break: break-all;
      }
    }
    .oce_break {
      overflow-wrap: break-word;
    }
    .oce_notice {
      margin-bottom: 20px;
      font-size: 23px;
      line-height: 27px;
      color: $grey;
      max-width: 510px;
      @media (max-width: $bp) {
        margin-bottom: 1.9vw;
        font-size: 2.2vw;
        line-height: 2.7vw;
      }
      @media (max-width: $bp-sm) {
        margin-bottom: 10px;
        font-size: 15px;
        line-height: 18px;
      }
    }
    .oce_ops {
      margin: 20px -30px 0;
      font-size: 20px;
      padding: 30px;
      @include border-radius(15px);
      &.oce_ops--on {
        background: rgba(0, 0, 0, .02);
        .oce_ops-body {
          display: block;
        }
      }
      @media (max-width: $bp) {
        font-size: 1.9vw;
        margin: 2.9vw 0 0;
      }
      @media (max-width: $bp-sm) {
        font-size: 14px;
        margin: 15px -20px 0;
        padding: 20px;
      }
      .oce_ops-trigger {
        border-bottom: 1px dotted;
        cursor: pointer;
        color: $color-2;
        text-decoration: none;
        font-weight: 800;
        &:hover {
          border-color: transparent;
        }
      }
      .oce_ops-body {
        display: none;
      }
      .oce_ops-item {
        margin: 25px -10px 0;
        padding: 10px;
        @include border-radius(5px);
        &:nth-of-type(2n+1) {
          background: rgba(101, 89, 222, .06);
        }
        @media (max-width: $bp) {
          margin: 2.9vw 0 0;
        }
        @media (max-width: $bp-sm) {
          margin: 15px 0 0;
        }
        .oce_ops-item-date {
          float: right;
          @media screen and (max-width: 650px) {
            display: block;
            text-align: right;
            float: none;
          }
        }
        .oce_ops-item-op {}
        .oce_ops-item-pers {
          color: $color-2;
          text-decoration: underline;
          display: inline-block;
          cursor: pointer;
          &:hover {
            text-decoration: none;
          }
        }
        a.oce_ops-item-pers {
          color: $color-2 !important;
        }
      }
    }
    .ops_print-wrap {
      margin: 50px 0 0;
      text-align: right;
      @media (max-width: $bp) {
        margin: 4.8vw 0 0;
      }
      @media (max-width: $bp-sm) {
        margin: 15px 0 0;
      }
    }
    .ops_print-lnk {
      padding: 10px 20px;
      @include border-radius(20px);
      background: rgba(0, 0, 0, .07);
      display: inline-block;
      cursor: pointer;
      @include transition(background);
      &:hover {
        background: rgba(100, 90, 220, .07);
      }
      &:before {
        content: '';
        display: inline-block;
        vertical-align: middle;
        margin: -5px 8px 0 0;
        width: 26px;
        height: 20px;
        background: 50% 50% no-repeat url(/static/grx/icons/printer.svg);
      }
    }
  }
  .of_back {
    position: absolute;
    left: 50%;
    margin-left: -680px;
    top: 110px + 25px;
    @media (max-width: 1440px) {
      left: 170px;
      margin-left: 0;
      top: 20px + 25px;
    }
  }
  .oce_print-only {
    display: none;
  }
  .pagebreak {
    page-break-before: always;
  }
}
@media print {
  html {
    padding-bottom: 0 !important;
  }
  .oce_page {
    position: relative;
  }
  .oce_ipu-title {
    font-size: 20px !important;
    line-height: 22px !important;
    text-align: right !important;
    position: absolute !important;
    top: 50px !important;
    right: 50px !important;
    font-weight: bold !important;
    width: 100% !important;
    span {
      display: block !important;
    }
  }
  .oce_holder {
    padding-left: 0 !important;
    .oce_holder-img {
      display: none;
    }
    .oce_holder-txt {
      color: $color-2;
      font-size: 13px;
      display: inline-block !important;
    }
  }
  .oce_print-only {
    display: block !important;
    .oce_logo {
      max-width: 140px !important;
    }
    .oce_ipu-title {
      font-size: 22px;
      font-weight: 400 !important;
    }
    .oce_page-title {
      margin-top: 20px !important;
    }
    .oce_title {
      margin-top: 0 !important;
    }
    .oce_ops {
      display: block !important;
    }
    .oce_ops-title {
      font-size: 20px;
      font-weight: 700;
    }
    .oce_ops-body {
      margin: 0 -10px !important;
    }
    .oce_ops-item {
      font-size: 16px !important;
      &:nth-of-type(2n+1) {
        -webkit-print-color-adjust: exact;
      }
      .oce_ops-item-pers {
        color: #000 !important;
        text-decoration: none !important;
      }
    }
  }
  .nav-top_ntp,
  .oce_grad-line,
  .ops_print-wrap,
  .page-footer_pfr,
  .oce_ops {
    display: none !important;
  }
  .oce_page {
    padding: 60px 70px !important;
  }
  .oce_logo {
    max-width: 240px !important;
  }
  .oce_ext {
    font-size: 14px;
  }
  .oce_ext-url {
    color: #000 !important;
    text-decoration: none !important;
  }
  .oce_files-hash_ofh {
    font-size: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/layouts/ObjectCertificate.vue